import React from 'react';
import { Button } from 'react-bootstrap';
import { FaChevronDown } from 'react-icons/fa';

const Hero = ({ scrollToSection }) => {
  return (
    <section id="home" className="hero">
      <div className="hero-bg"></div>
      <div className="hero-content">
        <h1>Where Everything is Possible</h1>
        <p>
          We are a team of freelance developers specializing in website development, 
          web design, mobile applications, and various IT services.
        </p>
        <div>
          <Button 
            variant="primary" 
            className="me-3"
            onClick={() => scrollToSection('contact')}
          >
            Get in Touch
          </Button>
          <Button 
            variant="outline-light"
            onClick={() => scrollToSection('services')}
          >
            Our Services
          </Button>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div 
        className="scroll-indicator"
        onClick={() => scrollToSection('about')}
      >
        <FaChevronDown />
      </div>
    </section>
  );
};

export default Hero;
